import { Separator } from "@/components/ui/separator";
import { BuscarCautelasCarrinhoDto } from "@/dtos/Request/RequestBuscarCautelasCarrinho";
import { ModalVisualizarTitulos } from "./ModalVisualizarTitulos";
import { labelPlural } from "@/utils/copyTituloBilhete";

interface FinalizarComprasResumoProps {
    dadosResumo: BuscarCautelasCarrinhoDto
}

export function FinalizarCompraResumo(props: FinalizarComprasResumoProps) {
    return (
        <div className="flex flex-col bg-slate-100 rounded-lg px-10 py-4 w-full">
            <h1 className="text-primary-foreground font-semibold text-xl my-2">Resumo da Compra</h1>


            <div className="flex justify-between">
                <span>Quantidade de {labelPlural()}</span><span className="font-medium">{props.dadosResumo.QuantidadeTitulos}</span>
            </div>
            <div className="flex justify-between">
                <span>Data Sorteio</span><span className="font-medium">{props.dadosResumo.DataSorteio}</span>
            </div >


            <div className="mt-8">
                <Separator />
                <div className="flex justify-between mt-2">
                    <span>Valor Total</span> <span className="font-bold">{props.dadosResumo.ValorTotal.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</span>
                </div>

                <div className="flex justify-center mt-10">
                    <ModalVisualizarTitulos cautelas={props.dadosResumo.Cautelas} />
                </div >
            </div>
        </div >
    )
}